import axios from 'axios';
import { submitLogs } from '../config/AWSGlobalLog';

const IPINFO_URL = 'https://ipinfo.io/json?token=ce2ed65c47d251';
const IPINFO_CACHE_KEY = 'ipinfo';
const GEO_CHECK_TIMEOUT_MS = 5000;

let ipInfoPromise = null;

/**
 * The viewer's ipinfo response ({ ip, country, ... }), fetched once per tab and shared by the
 * geo check and the stats calls. Resolves null if ipinfo fails or returns no country; never rejects.
 */
export const getIpInfo = () => {
  if (!ipInfoPromise) {
    ipInfoPromise = (async () => {
      try {
        const cached = sessionStorage.getItem(IPINFO_CACHE_KEY);
        if (cached) return JSON.parse(cached);
      } catch (_) {}

      try {
        const request = await fetch(IPINFO_URL);
        const jsonResponse = await request.json();
        if (!request.ok || !jsonResponse?.country) {
          console.log('ipinfo did not return a country', jsonResponse);
          return null;
        }
        try {
          sessionStorage.setItem(IPINFO_CACHE_KEY, JSON.stringify(jsonResponse));
        } catch (_) {}
        return jsonResponse;
      } catch (error) {
        submitLogs(JSON.stringify({ status: 'ERROR', message: 'ipinfo request failed', error: error.message }));
        return null;
      }
    })();
  }
  return ipInfoPromise;
};

const postGeoCheck = async (body) => {
  const res = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/public/api/event/checkGeoAccess`,
    body,
    { timeout: GEO_CHECK_TIMEOUT_MS }
  );
  return res.data?.data;
};

/**
 * Applies the event's country/IP restriction. The first call sends only the event id; ipinfo is only
 * used when the API answers `lookup_required`. Resolves false only when the API says the viewer is
 * blocked: ipinfo or API failures let the viewer in.
 */
export const checkGeoAccess = async (eventId) => {
  try {
    let result = await postGeoCheck({ eventId });
    if (result?.reason === 'lookup_required') {
      const ipInfo = await getIpInfo();
      result = await postGeoCheck(
        ipInfo ? { eventId, ip: ipInfo.ip, country: ipInfo.country } : { eventId, country: null }
      );
    }
    return result?.access !== false;
  } catch (error) {
    submitLogs(JSON.stringify({ status: 'ERROR', message: 'Geo access check failed', eventID: eventId, error: error.message }));
    return true;
  }
};
